import { useEffect, useState } from 'react';
import { getJerseyAvatarUrl } from '@/utils/jerseyAvatar';
import { getTeamLogoUrl } from '@/utils/teamLogo';

type MlbTeamMarkImageProps = {
  teamCode: string;
  /** Sport code (e.g. 'MLB', 'NBA', 'NFL'). Defaults to 'MLB' for backward compatibility. */
  sport?: string | null;
  className?: string;
  style?: React.CSSProperties;
};

/**
 * Watermark-style mark for headshots / card art: contest team folder primary,
 * then jersey-style fallback if the primary asset is missing.
 * For coloured logos beside matchup scores, use {@link MlbTeamLogoImage}.
 */
export function MlbTeamMarkImage({ teamCode, sport, className, style }: MlbTeamMarkImageProps) {
  const primary = getTeamLogoUrl(teamCode, sport);
  const fallback = getJerseyAvatarUrl(teamCode, sport);
  const [useFallback, setUseFallback] = useState(false);

  useEffect(() => {
    setUseFallback(false);
  }, [teamCode]);

  const src = useFallback ? fallback : primary || fallback;
  if (!src) return null;

  return (
    <img
      src={src}
      alt=""
      aria-hidden
      className={className}
      style={style}
      onError={e => {
        if (!useFallback && primary) {
          setUseFallback(true);
        } else {
          e.currentTarget.style.display = 'none';
        }
      }}
    />
  );
}
